import { useTranslation } from 'react-i18next';

import { ButtonClearFilters } from '@/ui-kit/table-filters/ButtonClearFilter';
import { FormFilters } from '@/ui-kit/table-filters/FormFilters';
import { parseBasesPeriod, PeriodFilter } from '@/ui-kit/table-filters/PeriodFilter';
import { SearchFilter } from '@/ui-kit/table-filters/SearchFilter';
import { SelectFilter } from '@/ui-kit/table-filters/SelectFilter';

import { CheckFilter } from '@/ui-kit/table-filters/CheckFilter';
import { ICheckField, IPeriodField, ISearchField, ISelectField } from '@/ui-kit/table-filters/filters.type';

export interface IAllUsersFiltersProps {
  fields: {
    userType?: ISelectField;
    userStatus?: ISelectField;
    kycStatus?: ISelectField;
    createdDate?: IPeriodField;
    usTaxResident?: ICheckField;
    search?: ISearchField;
  };
  clearFunction?: () => void;
}

export function AllUsersFilters({ fields, clearFunction }: IAllUsersFiltersProps) {
  const { t } = useTranslation();

  return (
    <FormFilters testid="allUsers-filters">
      <SearchFilter
        value={fields.search.value}
        onChange={fields.search.handleChange}
        options={fields.search.options}
        placeholder={t('components.molecules.search.placeholder')}
        initialValue={fields.search?.value?.key}
      />
      <SelectFilter field={fields.userStatus} label={t('pages.dashboard.users.filters.userStatus')} />
      <CheckFilter field={fields.usTaxResident} label={t('pages.dashboard.users.filters.flag.label')} />
      <PeriodFilter
        field={fields.createdDate}
        label={t('components.filters.date.creationDate')}
        selectBase={parseBasesPeriod(t)}
      />
      {!!clearFunction ? <ButtonClearFilters onClick={() => clearFunction()} /> : <></>}
    </FormFilters>
  );
}
